const open = false;

const reducer = (state = open, action) => {
  switch (action.type) {
    case 'open_search':
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
